import { FC } from 'react'
import { Route, Routes } from 'react-router'
import ContactUs from '../components/ContactUs'

export const ContactUsRoutes: FC = () => {
 return (
  <Routes>
   <Route path="" element={<ContactUs />} />
  </Routes>
 )
}
